import React from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';

import { useStyles } from './style';

interface IProps {
  errorMes: string;
}

export const CommonError = ({ errorMes }: IProps) => {
  const classes = useStyles();
  return (
    <Box component={'section'} className={classes.wrapper}>
      <ErrorOutlineRoundedIcon />
      <Typography component={'p'} variant={'body2'}>
        {errorMes}
      </Typography>
    </Box>
  );
};
